import { readerNotes } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function ReaderNotes() {
  return (
    <section className="w-full border-b border-foreground-900/10 bg-background-100">
      <div className="mx-auto w-full max-w-[1360px] px-4 py-16 md:px-8 md:py-24">
        <SectionHeading
          index="05"
          kicker="翻阅者的话"
          title="他们原本也是到处问人的那种"
        />

        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3 lg:gap-8">
          {readerNotes.map((note) => (
            <figure
              key={note.id}
              className="flex h-full flex-col rounded-lg border border-foreground-900/10 bg-background-50 p-6 md:p-7"
            >
              <span className="flex h-8 w-8 items-center justify-center font-heading text-3xl leading-none text-primary-500">
                <i className="ri-double-quotes-l"></i>
              </span>
              <blockquote className="mt-5 flex-1 text-sm leading-relaxed text-foreground-700 md:text-base">
                {note.text}
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3 border-t border-foreground-900/10 pt-5">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-100 text-sm text-secondary-900">
                  <i className="ri-user-3-line"></i>
                </span>
                <span className="text-sm text-foreground-600">{note.from}</span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}